import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    UploadApplicationDocumentDocument,
    type UploadApplicationDocumentMutation,
    type UploadApplicationDocumentMutationVariables,
} from '../../api/mutations/uploadApplicationDocument';
import { type ApplicationDocumentKind } from '../../api/types';

export type ApplicationDocumentValue = {
    type: ApplicationDocumentKind;
    files: File[];
};

const useUploadApplicationDocuments = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: ApplicationDocumentValue[]) => {
            if (values.length < 1) {
                return null;
            }

            await Promise.all(
                values
                    .map(value =>
                        value.files.map(file => {
                            if (file instanceof File) {
                                return apolloClient.mutate<
                                    UploadApplicationDocumentMutation,
                                    UploadApplicationDocumentMutationVariables
                                >({
                                    mutation: UploadApplicationDocumentDocument,
                                    variables: {
                                        token,
                                        kind: value.type,
                                        upload: file,
                                    },
                                });
                            }

                            return null;
                        })
                    )
                    .filter(Boolean)
            );

            return null;
        },

        [apolloClient]
    );
};

export default useUploadApplicationDocuments;
